/**
 * Base class for resource printing lists.
 *
 * @type {ngController}
 */
export class tmrOperationPrintController {
  static ngType = 'controller'

  constructor($state, TmrPrint, TmrPrintModal) {
    'ngInject'
    Object.assign(this, { $state, TmrPrint, TmrPrintModal })
  }

  $onInit() {
    if (
      !this.TmrPrint.printCartEnabled &&
      this.TmrPrint.resourcesToPrint === undefined
    )
      throw new Error(
        'Controller tmrOperationPrintController requires a route with a resourcesToPrint param.'
      )

    if (this.TmrPrint.resourcesToPrint.length)
      this.resources.forEach(resource => {
        if (this.TmrPrint.isResourceToPrint(resource)) resource.$toPrint = true
      })
  }

  /** Default options for TmrPrintModal, called by {@link tmrOperationPrintController#askPrint} */
  printModalOptions(resource) {
    return {
      resource,
      requested: resource.printCounters.requested ?? 0,
      printed: resource.printCounters.printed ?? 0,
      askQuantity: true,
      relativeTo: `.printable-row-${resource.id}`,
    }
  }

  askPrint($event, resource) {
    return this.TmrPrintModal(
      $event,
      () => this.onPrint(),
      this.printModalOptions(resource)
    )
  }

  /** Print requested sent event */
  onPrint() {
    // Reload print queue count and last print date.
    return this.$state.reload()
  }

  onPrintClear() {
    this.resources.forEach(resource => (resource.$toPrint = false))
    return this.TmrPrint.clearResourcesToPrint()
  }

  onPrintRemove(toRemove) {
    // Try to use a resolved resource if present; if not, use the passed toRemove object.
    let resource =
      this.resources.find(res => this.TmrPrint.isSameResource(toRemove, res)) ??
      toRemove
    resource.$toPrint = false
    return this.TmrPrint.removeResourcesToPrint(resource)
  }

  isToggleAllChecked() {
    return this.resources.every(({ $toPrint }) => $toPrint)
  }

  isToggleAllIndeterminate() {
    return (
      this.resources.some(res => res.$toPrint) &&
      !this.resources.every(res => res.$toPrint)
    )
  }

  toggleToPrint(resource) {
    let isToPrint = this.TmrPrint.isResourceToPrint(resource)
    if (resource.$toPrint && !isToPrint)
      return this.TmrPrint.addResourcesToPrint(resource)
    else if (!resource.$toPrint && isToPrint)
      return this.TmrPrint.removeResourcesToPrint(resource)
  }

  toggleToPrintAll() {
    let allChecked = this.isToggleAllChecked()
    let toToggle = []
    this.resources.forEach(resource => {
      // XNOR.
      if (allChecked == this.TmrPrint.isResourceToPrint(resource))
        toToggle.push(resource)
    })
    if (toToggle.length) {
      toToggle.forEach(resource => (resource.$toPrint = !allChecked))
      if (allChecked) return this.TmrPrint.removeResourcesToPrint(toToggle)
      else return this.TmrPrint.addResourcesToPrint(toToggle)
    }
  }
}
